.container {
  width: 400px;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-y: auto;
  margin: auto;
}

.logo {
  width: 96px;
  height: 72px;
  object-fit: contain;
}

.title {
  font-size: 22px;
  color: var(--tealish);
  font-weight: 300;
  margin: 15px 0 10px 0;
  text-align: center;
}

.description {
  font-size: 14px;
  color: var(--brown-grey);
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.5;
}

.clientName {
  font-weight: 600;
  color: var(--marine);
}

.form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.label {
  margin-left: 3px;
  font-size: 12px;
  color: var(--brown-grey);
  margin-bottom: 4px;
}

.selectWrapper {
  width: 100%;
  margin-bottom: 20px;
}

.buttons {
  display: flex;
  gap: 12px;
  width: 100%;
  margin-top: 10px;
}

.authorize {
  flex: 1;
  height: 36px;
  font-size: 14px;
  background-color: var(--marine);
  color: var(--fully-white);
  border-radius: 5px;
  border: 0;
  cursor: pointer;
}

.authorize:hover {
  opacity: .8;
}

.authorize:disabled {
  opacity: .5;
  cursor: not-allowed;
}

.deny {
  flex: 1;
  height: 36px;
  font-size: 14px;
  background-color: transparent;
  color: var(--brown-grey);
  border-radius: 5px;
  border: 1px solid var(--bb-grey);
  cursor: pointer;
}

.deny:hover {
  background-color: var(--light-grey);
}

.error {
  font-size: 12px;
  color: var(--warm-pink);
  margin-top: 10px;
  text-align: center;
  width: 100%;
}

.scopes {
  width: 100%;
  margin-bottom: 15px;
  padding: 12px;
  background-color: var(--light-grey);
  border-radius: 5px;
}

.scopeTitle {
  font-size: 12px;
  color: var(--brown-grey);
  margin-bottom: 6px;
}

.scopeItem {
  font-size: 13px;
  color: var(--marine);
  padding: 3px 0;
}
